import { t } from '@/i18n'; 
import { Button } from '@chikara/ui';
import styles from './MfaValidation.module.css';
import { MfaIntroProps, Step } from '@/features/auth/types/mfa.types';


export function MfaIntro({ onContinue }: MfaIntroProps) {
	const steps = t('mfaIntro.steps') as Step[];
		
	return (
		<section className={styles.section}>
			<div className={styles.header}>
				<h2 className={styles.title}>{t('mfaIntro.title')}</h2>
				<p className={styles.subTitle}>{t('mfaIntro.subtitle')}</p>
			</div>

			<ol className={styles.list}>
				{steps.map((step, index) => {
					const entry = Object.entries(step)[0];
					const [boldText, normalText] = entry ?? [];

					return (
						<li key={index}>
							<strong>{boldText}</strong> {normalText}
						</li>
					);
				})}
			</ol>
			
			<Button className={styles.submitButton} onClick={onContinue}>
				{t('mfaIntro.action')}
			</Button>
		</section>
	);
}
